package br.com.vvrefeicoes.portal.domain.model

data class ConsolidatedMonth(
    val period: MonthPeriod,
    val realRevenueCents: Long,
    val realExpenseCents: Long,
    val plannedRevenueCents: Long,
    val plannedExpenseCents: Long,
) {
    val realResultCents: Long
        get() = realRevenueCents - realExpenseCents

    val plannedResultCents: Long
        get() = plannedRevenueCents - plannedExpenseCents

    val realProfitPercent: Double
        get() = if (realRevenueCents == 0L) 0.0 else realResultCents.toDouble() / realRevenueCents * 100

    val plannedProfitPercent: Double
        get() = if (plannedRevenueCents == 0L) 0.0 else plannedResultCents.toDouble() / plannedRevenueCents * 100
}
